import React, { memo } from 'react';
import { XCircleIcon, DollarSignIcon, ClockIcon, PillIcon, ActivityIcon } from 'lucide-react';
const Knowledge = () => {
  const handleCTAClick = () => {
    // Puedes añadir un evento de seguimiento aquí si lo deseas
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  return <section className="py-16 md:py-24 bg-white" data-id="element-258">
      <div className="container mx-auto px-4 md:px-6" data-id="element-259">
        <div className="max-w-4xl mx-auto" data-id="element-260">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-[#1e293b]" data-id="element-261">
            La verdad es que cada episodio de dolor tiene un{' '}
            <span className="relative inline-block text-[#e53e3e]" data-id="element-262">
              costo oculto
              <span className="absolute -bottom-1 left-0 w-full h-1 bg-[#e53e3e] rounded-full" data-id="element-263"></span>
            </span>
            :
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-264">
            <div className="bg-[#f8f9ff] p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-l-4 hover:border-[#e53e3e] group" data-id="element-265">
              <div className="flex items-start" data-id="element-266">
                <ClockIcon size={24} className="text-[#e53e3e] mr-4 mt-1 shrink-0 group-hover:scale-110 transition-transform" data-id="element-267" />
                <div data-id="element-268">
                  <h3 className="text-xl font-semibold mb-2 text-[#1e293b] group-hover:text-[#e53e3e] transition-colors" data-id="element-269">
                    Horas de trabajo perdidas
                  </h3>
                  <p className="text-[#4a5568]" data-id="element-270">
                    Productividad que se evapora mientras luchas contra el
                    dolor.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#f8f9ff] p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-l-4 hover:border-[#e53e3e] group" data-id="element-271">
              <div className="flex items-start" data-id="element-272">
                <XCircleIcon size={24} className="text-[#e53e3e] mr-4 mt-1 shrink-0 group-hover:scale-110 transition-transform" data-id="element-273" />
                <div data-id="element-274">
                  <h3 className="text-xl font-semibold mb-2 text-[#1e293b] group-hover:text-[#e53e3e] transition-colors" data-id="element-275">
                    Oportunidades canceladas
                  </h3>
                  <p className="text-[#4a5568]" data-id="element-276">
                    Eventos, reuniones y momentos importantes que nunca
                    recuperarás.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#f8f9ff] p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-l-4 hover:border-[#e53e3e] group" data-id="element-277">
              <div className="flex items-start" data-id="element-278">
                <PillIcon size={24} className="text-[#e53e3e] mr-4 mt-1 shrink-0 group-hover:scale-110 transition-transform" data-id="element-279" />
                <div data-id="element-280">
                  <h3 className="text-xl font-semibold mb-2 text-[#1e293b] group-hover:text-[#e53e3e] transition-colors" data-id="element-281">
                    Medicinas que solo "parchan"
                  </h3>
                  <p className="text-[#4a5568]" data-id="element-282">
                    Tratamientos temporales que no solucionan la causa raíz.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-[#f8f9ff] p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-l-4 hover:border-[#e53e3e] group" data-id="element-283">
              <div className="flex items-start" data-id="element-284">
                <ActivityIcon size={24} className="text-[#e53e3e] mr-4 mt-1 shrink-0 group-hover:scale-110 transition-transform" data-id="element-285" />
                <div data-id="element-286">
                  <h3 className="text-xl font-semibold mb-2 text-[#1e293b] group-hover:text-[#e53e3e] transition-colors" data-id="element-287">
                    Terapias que no funcionan
                  </h3>
                  <p className="text-[#4a5568]" data-id="element-288">
                    Inversiones constantes en soluciones que prometen pero no
                    cumplen.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-r from-[#eef2ff] to-[#e0e7ff] p-8 rounded-xl border border-[#dbeafe] mb-12 transform transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-289">
            <div className="flex items-center mb-4" data-id="element-290">
              <DollarSignIcon size={28} className="text-[#6366f1] mr-3 animate-bounce" data-id="element-291" />
              <h3 className="text-2xl font-bold text-[#1e293b] relative inline-block" data-id="element-292">
                $2,900 USD
                <span className="absolute -bottom-1 left-0 w-full h-1 bg-[#6366f1] rounded-full" data-id="element-293"></span>
              </h3>
            </div>
            <p className="text-lg text-[#4a5568] mb-2" data-id="element-294">
              Un estudio reciente estima que las personas con migrañas crónicas
              pierden hasta{' '}
              <span className="font-semibold bg-yellow-100 px-1 rounded" data-id="element-295">
                $2,900 USD al año
              </span>{' '}
              en productividad y tratamientos.
            </p>
            <p className="text-lg text-[#4a5568] font-medium italic" data-id="element-296">
              Pero nadie te lo dice.{' '}
              <span className="text-[#6366f1] font-bold" data-id="element-297">Hasta ahora.</span>
            </p>
          </div>
          <div className="bg-gradient-to-r from-[#8b5cf6] to-[#6366f1] p-8 rounded-xl text-white shadow-lg transform transition-all hover:shadow-xl hover:-translate-y-1 duration-300" data-id="element-298">
            <h3 className="text-2xl font-bold mb-4 relative inline-block" data-id="element-299">
              SOLUCIÓN: RUTINA TERAPÉUTICA INTELIGENTE
              <span className="absolute -bottom-1 left-0 w-full h-1 bg-white rounded-full" data-id="element-300"></span>
            </h3>
            <p className="text-lg mb-6" data-id="element-301">
              Este dispositivo interrumpe ese ciclo silencioso. Usa tecnología
              terapéutica validada clínicamente para iniciar el alivio tras 15
              minutos de uso rutinario.
            </p>
            <div className="bg-white/20 p-5 rounded-lg backdrop-blur-sm mb-6 hover:bg-white/30 transition-colors" data-id="element-302">
              <h4 className="text-xl font-semibold mb-3" data-id="element-303">
                Puedes usarlo frío o caliente:
              </h4>
              <ul className="space-y-2" data-id="element-304">
                <li className="flex items-center group transition-transform duration-200 hover:translate-x-1" data-id="element-305">
                  <div className="w-2 h-2 bg-white rounded-full mr-3 group-hover:scale-150 transition-transform" data-id="element-306"></div>
                  <span data-id="element-307">Frío: 10 a 15 minutos</span>
                </li>
                <li className="flex items-center group transition-transform duration-200 hover:translate-x-1" data-id="element-308">
                  <div className="w-2 h-2 bg-white rounded-full mr-3 group-hover:scale-150 transition-transform" data-id="element-309"></div>
                  <span data-id="element-310">Calor: hasta 10 minutos</span>
                </li>
                <li className="flex items-center group transition-transform duration-200 hover:translate-x-1" data-id="element-311">
                  <div className="w-2 h-2 bg-white rounded-full mr-3 group-hover:scale-150 transition-transform" data-id="element-312"></div>
                  <span data-id="element-313">Ajusta según tu tolerancia y necesidad</span>
                </li>
              </ul>
            </div>
            <p className="text-lg font-medium mb-6" data-id="element-314">
              Sin pastillas. Sin efectos secundarios. Sin fricción.
            </p>
            <button className="bg-white text-[#6366f1] hover:bg-gray-100 px-8 py-3 rounded-full text-lg font-medium transition-all transform hover:scale-105 shadow-md flex items-center justify-center group" onClick={handleCTAClick} data-id="element-315">
              👉 Empieza tu rutina de alivio hoy
              <span className="ml-1 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300" data-id="element-316">
                →
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(Knowledge);